/* eslint-disable camelcase */
import {createIntl, createIntlCache} from 'react-intl';
import messages_pt_br from '../i18n/pt-br';
import messages_en from '../i18n/en';

const messages = {
    'pt': messages_pt_br,
    'en': messages_en,
};

export class PlatformIntl {
    static DEFAULT_LOCALE = navigator.language.split(/[-_]/)[0];
    static ACTIVE_MESSAGES = messages[PlatformIntl.DEFAULT_LOCALE];

    static instance = null;
    static intlService = null;


    /**
     * Description
     * @return {PlatformIntl}
     */
    static getInstance() {
        if (PlatformIntl.instance == null) {
            PlatformIntl.instance = new PlatformIntl();
            PlatformIntl.init();
        }
        return PlatformIntl.instance;
    }

    static init() {
        const cache = createIntlCache();
        PlatformIntl.intlService = createIntl({
            locale: PlatformIntl.DEFAULT_LOCALE,
            messages: PlatformIntl.ACTIVE_MESSAGES,
        }, cache);
    }

    formatMessage(key, options = {}) {
        const fallbackMessage = options?.fallbackMessage;
        const format = options?.format;

        return PlatformIntl.intlService.formatMessage({
            id: key,
            defaultMessage: fallbackMessage,
        }, format);
    }
}
